export default __webpack_public_path__ + "static/media/banner_about2.442a8e7e.jpg";